import { Typography } from '@mui/material';
import BasicSelect from 'further-ui/components/BasicSelect';
import { Column } from 'further-ui/components/Layout';
import useDayCountOptions from 'hooks/lp/data/vehicle/useDayCountOptions';
import { CarriedInterestDayCountFormat } from 'further-types/lp/carry-settings';

type Props = {
  value: CarriedInterestDayCountFormat;
  onChange: (value: CarriedInterestDayCountFormat) => void;
  error?: boolean;
};

const DayCountSelect: React.FC<Props> = ({ value, onChange, error }) => {
  const dayCountOptions = useDayCountOptions();
  const selectedOption = dayCountOptions.find((o) => o.value === value);

  return (
    <Column spacing="lg" fullWidth>
      <BasicSelect
        fullWidth
        size="small"
        options={dayCountOptions}
        value={value}
        onChange={onChange}
        error={error}
      />
      {selectedOption?.description && (
        <Typography variant="body2">
          <i>{selectedOption.label}</i>{' '}
          {selectedOption.description.charAt(0).toLowerCase() +
            selectedOption.description.slice(1)}
        </Typography>
      )}
    </Column>
  );
};

export default DayCountSelect;
